import React from "react";
import { GsdModuleNavItem } from "./GsdModuleNavItem.jsx";

/**
 * Horizontal role / section tabs (GolfMAP / PokerPUR pattern).
 * @param {object} props
 * @param {Array<{ id: string, label: string, icon?: string }>} props.tabs
 * @param {string} [props.activeId]
 * @param {(id: string) => void} [props.onSelect]
 * @param {string} [props.testId]
 */
export function GsdRoleTabs({ tabs = [], activeId, onSelect, testId = "gsd-role-tabs" }) {
  return (
    <div className="gsd-role-tabs" role="tablist" aria-label="Sections" data-testid={testId}>
      {tabs.map((tab) => {
        const active = tab.id === activeId;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={`gsd-role-tabs__tab${active ? " gsd-role-tabs__tab--active" : ""}`}
            onClick={() => onSelect?.(tab.id)}
            data-testid={`gsd-role-tab-${tab.id}`}
          >
            {tab.icon ? <span aria-hidden="true">{tab.icon}</span> : null}
            <span>{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
}

/**
 * Top navigation groups (Public / Mon espace / Admin).
 * @param {object} props
 * @param {Array<{ id: string, label: string, items: object[] }>} props.groups
 * @param {(item: object, meta: object) => React.ReactNode} [props.renderLink]
 * @param {(item: object) => boolean} [props.isItemActive]
 * @param {string} [props.className]
 * @param {string} [props.testId]
 */
export function GsdTopNavGroups({ groups = [], renderLink, isItemActive, className = "", testId = "gsd-top-nav" }) {
  return (
    <nav className={`gsd-top-nav${className ? ` ${className}` : ""}`} aria-label="Navigation principale" data-testid={testId}>
      {groups.map((group) => (
        <div key={group.id} className={`gsd-top-nav__group gsd-top-nav__group--${group.id}`} data-testid={`gsd-nav-group-${group.id}`}>
          <span className="gsd-top-nav__group-label">{group.label}</span>
          <div className="gsd-top-nav__items">
            {group.items.map((item) => (
              <GsdModuleNavItem
                key={item.id}
                item={item}
                isActive={isItemActive ? isItemActive(item) : false}
                renderLink={renderLink}
              />
            ))}
          </div>
        </div>
      ))}
    </nav>
  );
}
